var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFvSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9671 13.783V23.2198C13.9671 23.8366 13.2839 24.208 12.7638 23.8754L10.4529 22.3898L8.50111 21.1344L6.54838 22.3898L4.2375 23.8754C3.71828 24.207 3.03516 23.8366 3.03516 23.2198V13.783H13.9671Z",
    fill: "#F41943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4524 13.783V22.3898L8.50062 21.1353L6.54883 22.3898V13.783H10.4524Z",
    fill: "#EBF2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9653 13.783V14.9995C13.214 15.5178 11.9851 16.2236 10.4512 16.5969V13.783H13.9653Z",
    fill: "#C6123D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4524 13.783V16.5969C9.80813 16.7542 9.10984 16.8518 8.37176 16.8518C7.72748 16.8518 7.11731 16.776 6.54883 16.651V13.7839H10.4534L10.4524 13.783Z",
    fill: "#C3DBDA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54837 13.7829V16.65C5.03621 16.3155 3.81777 15.6305 3.03516 15.0885V13.782H6.54837V13.7829Z",
    fill: "#C6123D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50043 16.1923C12.9718 16.1923 16.5966 12.5675 16.5966 8.09613C16.5966 3.62476 12.9718 0 8.50043 0C4.02906 0 0.404297 3.62476 0.404297 8.09613C0.404297 12.5675 4.02906 16.1923 8.50043 16.1923Z",
    fill: "#EBF2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50105 15.4723C12.5747 15.4723 15.8771 12.17 15.8771 8.09627C15.8771 4.02259 12.5747 0.720215 8.50105 0.720215C4.42737 0.720215 1.125 4.02259 1.125 8.09627C1.125 12.17 4.42737 15.4723 8.50105 15.4723Z",
    fill: "#C3DBDA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4253 8.09623C15.4253 11.9145 12.3195 15.0213 8.50123 15.0213C7.41827 15.0213 6.39311 14.7712 5.47975 14.3268C4.52659 13.8625 3.69566 13.186 3.04759 12.3598C2.75198 11.9828 2.49427 11.5734 2.28109 11.1386C1.83009 10.2205 1.57617 9.18677 1.57617 8.09623C1.57617 7.28709 1.71545 6.51111 1.97127 5.78914C2.74156 3.61375 4.57112 1.93578 6.83558 1.37488C7.369 1.24223 7.92706 1.17212 8.50123 1.17212C9.77842 1.17212 10.976 1.51984 12.004 2.12433C12.4626 2.39436 12.8871 2.71555 13.2708 3.08032C13.9937 3.76819 14.5688 4.61049 14.9421 5.55417C15.2548 6.34152 15.4263 7.19898 15.4263 8.09623H15.4253Z",
    fill: "#EBF2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0021 2.12433L2.27914 11.1386C1.82814 10.2205 1.57422 9.18677 1.57422 8.09623C1.57422 7.28709 1.7135 6.51111 1.96931 5.78914L6.83362 1.37488C7.36705 1.24223 7.92511 1.17212 8.49928 1.17212C9.77647 1.17212 10.9741 1.51984 12.0021 2.12433Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9414 5.55395L5.47903 14.3266C4.52588 13.8623 3.69494 13.1858 3.04688 12.3596L13.2701 3.08105C13.993 3.76892 14.5681 4.61122 14.9414 5.5549V5.55395Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFvSilver);
export default __webpack_public_path__ + "static/media/fv-silver.db8b09aa17d8fc91529ff08b93af06c8.svg";
export { ForwardRef as ReactComponent };